"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AbsoluteBox = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const Box_1 = require("../Box");
exports.AbsoluteBox = react_1.forwardRef(function AbsoluteBox(props, ref) {
    return jsx_runtime_1.jsx(Box_1.Box, Object.assign({ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, ref: ref }, props), void 0);
});
//# sourceMappingURL=index.js.map